import theme from '~/styles/theme';

export const profileNameLinkStyle = {
  borderBottom: '1px solid transparent',
  transition: 'border-bottom 0.3s ease, padding-bottom 0.3s ease',
  _hover: {
    borderBottom: `1px solid ${theme.colors.secondary[500]}`,
    paddingBottom: '2px',
  },
};

export const stackNameLinkStyle = {
  lineHeight: '1',
  borderBottom: '2px solid transparent',
  transition: 'border-bottom 0.3s ease, margin-bottom 0.3s ease',
  _hover: {
    borderBottom: `2px solid ${theme.colors.secondary[500]}`,
    marginBottom: '0px',
  },
};
